<div class="huomautus-oranssi">
  {{ 'lasku.eu-kuluttajamyynti.huomautus' | translate | async }}
  <button type="button" class="lue-lisaa" (click)="avaaLueLisaa()">{{ 'lasku.eu-kuluttajamyynti.lue-lisaa' | translate | async }} ›</button>
</div>
